import React, { useEffect } from 'react';
import "./SportOneHome.scss";
import SportOneHero from "../sportOneComponents/SportOneHero";
import SportOneSubscription from "../sportOneComponents/SportOneSubscription";
import SportOneCategories from "../sportOneComponents/SportOneCategories";
import SportOneW18Events from '../sportOneComponents/SportOneW18Events';
import SportOneW18Cards from "../sportOneComponents/SportOneW18Cards";
import SportOneWellnessHubCard from "../sportOneComponents/SportOneWellnessHubCard";
import SportOneJoinFamily from "../sportOneComponents/SportOneJoinFamily";
import SportOneWeAreW18 from "../sportOneComponents/SportOneWeAreW18";
import SportOnePhilosophy from "../sportOneComponents/SportOnePhilosophy";
import SportOneOurPartners from "../sportOneComponents/SportOneOurPartners";


const SportOneHome = () => {
  useEffect(() => {
    const sections = document.querySelectorAll(".sport-one-fade-section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          } else {
            entry.target.classList.remove("in-view");
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  return (
    <div className="sport-one-home">
      <SportOneHero />
      <SportOneSubscription />
      <SportOneCategories />
     <SportOneW18Events/>
      <SportOneW18Cards />
      <SportOnePhilosophy />
      <SportOneWellnessHubCard />
      <SportOneJoinFamily />
      <SportOneWeAreW18 /> 
      <SportOneOurPartners />
    </div>
  );
};
export default SportOneHome;